import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../shared/services/navigation.service';
import { ILayoutConf, LayoutService } from 'app/shared/services/layout.service';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
})
export class SidebarSideComponent implements OnInit, OnDestroy {
  public primaryMenuItems: any[] = [];
  public menuItems: any[] = [];
  public activeMenuItem: any;
  public showContextPanel = true;
  public layoutConf: ILayoutConf;

  private allMenuItems: any[] = [];
  private menuItemsSub: Subscription;
  private permissionsSub: Subscription;
  private routerSub: Subscription;
  private userType = '';

  constructor(
    private navService: NavigationService,
    private layout: LayoutService,
    private jwtAuth: JwtAuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;

    this.menuItemsSub = this.navService.menuItems$.subscribe((items) => {
      this.allMenuItems = items || [];
      this.updateNavigation();
    });

    this.permissionsSub = this.jwtAuth.permissions$.subscribe((permissions) => {
      this.userType = String(permissions?.user_type ?? '').toLowerCase();
      this.updateNavigation();
    });

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateNavigation();
      }
    });
  }

  ngOnDestroy(): void {
    this.menuItemsSub?.unsubscribe();
    this.permissionsSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }

  private updateNavigation(): void {
    this.primaryMenuItems = this.filterPrimaryMenuItems(this.allMenuItems);

    const pathSegments = this.router.url
      .split('?')[0]
      .split('/')
      .filter(Boolean);
    const currentSection = pathSegments[0] || '';

    this.activeMenuItem = this.primaryMenuItems.find((item) =>
      item.url_slug === currentSection || item.state === currentSection
    );

    // PMS contextual links require a selected product id. Keep the primary
    // icon rail available, but hide the empty contextual panel otherwise.
    const isPmsProductRoute = currentSection === 'pms' && !!pathSegments[2];
    this.showContextPanel = currentSection !== 'pms' || isPmsProductRoute;
    this.menuItems = this.activeMenuItem?.side_nav ?? [];
  }

  private filterPrimaryMenuItems(items: any[]): any[] {
    if (this.userType === 'supplier') {
      return items.filter((item) => ['PMS', 'Sales'].includes(item.name));
    }

    if (this.userType === 'merchant') {
      return items.filter((item) =>
        ['PMS', 'Sales', 'Wallet', 'Webhook'].includes(item.name)
      );
    }

    return items.filter((item) =>
      !item.disabled && !['Wallet', 'Webhook'].includes(item.name)
    );
  }
}
